import { FullVideoData } from "@/models/FullVideoData"
import { ThemeData } from "./ThemeData"

export default interface IGlobalData {
  baseurlAdminAppUrl: string
  isLocalhost: boolean
  localbase: string
  analyticsEventsCaptureEndPoint: string
  socialShareUrl: string
  PublishedWebinarDataEndPoint: string
  videoPlayers: Array<HTMLVideoElement>
  isGated: boolean
  queryEndpoint: string
  theme_data: ThemeData
  time_data: {
    startTime: string | undefined
    endTime: string | undefined
    screenshotTime: string | undefined
  }
  eventElement: HTMLElement | undefined
  autoPlay: boolean
  fullVideoInfo: FullVideoData
  redirect_data: { url: string | null; text: string | null }
  height: number
}
export class GlobalData implements IGlobalData {
  baseurlAdminAppUrl = "https://go.parmonic.com/"
  isLocalhost = window.location.host.indexOf("localhost") > -1
  localbase = `${window.location.protocol}//${window.location.host.replace(
    "8080",
    "3000"
  )}/`
  analyticsEventsCaptureEndPoint = ""
  socialShareUrl = ""
  PublishedWebinarDataEndPoint = "https://awapi.blob.core.windows.net/awd/"
  videoPlayers = []
  isGated = false
  queryEndpoint = ""
  theme_data = {
    font_color: "#000000",
    font_family: "Arial, Helvetica, sans-serif",
    font_size: 11,
    theme_color: "#7E24B2"
  }
  time_data = {
    startTime: undefined,
    endTime: undefined,
    screenshotTime: undefined
  }
  eventElement = undefined
  autoPlay = false
  fullVideoInfo = new FullVideoData(undefined, undefined)
  redirect_data = { url: null, text: null }
  height = 0
}
